var exports = {
  "i": "xaee3c4fa--b72814--wrapper",
  "x": "xaee3c4fa--b72814--button",
};

module.exports = exports;
